module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_zx.64760d3a.png";